
/**
 * FOR DSL 003 CU-001: serials typed by hand must be strictly alphanumeric.
 *
 * This is applied ONLY at the manual-input boundary. It cannot be a global
 * rule: the system itself generates four serial formats that would fail it
 * (uuid-prefixed automatic serials, `_REINGRESO`, `-SUB-`, `-SUBSERIE-`).
 */
export const SERIE_PATTERN = /^[A-Za-z0-9]+$/;

/**
 * Canonical form is UPPERCASE because the backend uppercases on save
 * (api/utiles/series_normalizer.py). Normalizing differently here would make
 * the frontend and the database disagree on what "the same serial" is.
 */
export const normalizarSerie = (serie: string) => serie.trim().toUpperCase();

/**
 * Manual entry accepts ONE serial at a time, so a pasted block is rejected
 * instead of being split: the separators (space, comma, newline) are exactly
 * the characters CU-001 forbids, and splitting them would silently turn a
 * typo like "ABC 123" into two perfectly valid serials.
 */
export const esSerieValida = (serie: string) => SERIE_PATTERN.test(normalizarSerie(serie));

/**
 * Mirrors Series.observacion = CharField(max_length=255) (migration
 * 0695_series_observacion). Enforced at the input so a long note fails while
 * the operator is still typing, instead of after submitting the whole ingreso.
 */
export const OBSERVACION_SERIE_MAX = 255;
